import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _JobRequisition, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { SelectFunctionalArea } from "../../../../admin/configuracion/FunctionalArea/SelectFunctionalArea";
import { SelectFunctionalID } from "../../../../admin/configuracion/functionalID/SelectFunctionalID";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Aprove: string;
}

type SignedApprove = {
    IDAccount: number;
    Approved: boolean;
    Date: string;
};

export const SCVA004 = ({ configProcedure }: Props) => {

    const props = configProcedure?._pocessData?.Props ?? {};
    const procedure = configProcedure?._procedure ?? {};

    const { instance, bean, setBean } = useDataBean(_JobRequisition)

    const [response, setResponse] = useState<Resp>({
        Aprove: "",
        Obs: ""
    })

    useEffect(() => {
        if (props?.IDJobRequisition) {
            instance.getJobRequisition(props?.IDJobRequisition).then(
                (resp) => {
                    setBean(resp)
                }
            ).catch(err => { toast.error("No se pudo Cargar la informacion de la solicitud, intentelo mas tarde") })
        }
    }, [props?.IDJobRequisition])

    const onExportMap = () => {
        configProcedure?._pushInfo?.(
            _single.jsonToBootstrapTable({
                "Solicitud": `${response.Aprove == "true" ? "Aprobada" : "Rechazada"}`,
                "Jusitificación": response.Obs,
            })
        );
        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(response)
        }
    }


    const updateData = () => {
        if (response.Obs.trim().length < 15) {
            toast.error("La observación es obligatoria y debe tener al menos 15 caracteres.");
            setResponse({ ...response, Aprove: "" })
            return;
        }

        const signedList: SignedApprove[] = JSON.parse(bean.JSONApproveList || "[]");

        const newSign: SignedApprove = {
            IDAccount: _single.getAccountID(),
            Approved: response.Aprove === "true",
            Date: _single.getCurrenDate(),
        };

        signedList.push(newSign);

        const x = {
            ...bean,
            State: response.Aprove == "true" ? 2 : 3,
            JSONApproveList: JSON.stringify(signedList)
        };

        instance.updateJobRequisition(x).then(
            (resp) => {
                onExportMap();
            }
        ).catch(err => { toast.error("No se pudo realizar la accion") })
    }


    useEffect(() => {
        if (response.Aprove !== "") {
            updateData();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        setResponse(prev => ({ ...prev, Aprove: `${app}` }));
    }

    return (
        <div className="container-fluid">

            <div className="card mb-3">
                <div className="card-body">
                    <div className="row">
                        <div className="col-md-6">
                            <label >Unidad Organizacional</label>
                            <SelectFunctionalID disable={props.IDLnFunctionalID} functionalIDLn={props.IDLnFunctionalID} label=" " onChange={() => { }} />
                        </div>

                        <div className="col-md-6">
                            <label>Plaza Laboral</label>
                            <SelectFunctionalArea value={props.IDLnFunctionalArea} disable={true} label=" " onChange={() => { }} />
                        </div>
                    </div>

                </div>
            </div>


            <div className="mb-3">
                <label className="fw-bold">Observaciones</label>
                <textarea
                    className="form-control mt-1"
                    rows={3}
                    value={response.Obs}
                    onChange={(e) =>
                        setResponse(prev => ({ ...prev, Obs: e.target.value }))
                    }
                />
            </div>

            <div className="d-flex justify-content-between mt-4">

                <BasicButton disable={!bean.IDJobRequisition} icon="ri-checkbox-circle-line" eventClick={() => { updateForm(true) }} >Aprobar</BasicButton>

                <BasicButton disable={!bean.IDJobRequisition} icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>

            </div>
        </div>
    );
}